// @ts-nocheck
// Κοινή πηγή πεδίων ναύλου — ΜΙΑ συνάρτηση, ΔΥΟ καταναλωτές.
// Εξήχθη από DocumentsManager.mapBookingForBP() (v4.9).
//   1) Boarding pass  → Fleet / Documents  (DocumentsManager.tsx)
//   2) Sea scooter terms placeholders → CharterAgreementPage.tsx
// Ίδια πηγή δεδομένων και στους δύο: getAllBookings() → bookings.booking_data.
import { codeMatches } from '../utils/searchUtils';

// Σημερινή ημερομηνία, ΤΟΠΙΚΗ ζώνη (όχι toISOString() — αυτό γυρίζει UTC και
// μετά τις 03:00 Αθήνας θα έδινε τη χθεσινή).
export function todayISO() {
  const d = new Date();
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export function mapBookingFields(b) {
  if (!b) return null;
  const sync = b._sync || {};

  // Σειρά προτεραιότητας ΙΔΙΑ με την αρχική mapBookingForBP (sync → skipper).
  // Το flat chartererFirstName/LastName μπαίνει ως ΕΠΙΠΛΕΟΝ fallback στη μέση:
  // καθαρά προσθετικό, δεν αλλάζει κανένα boarding pass που δούλευε ήδη.
  // .trim(): ο ναύλος 780 έχει "Isabelle " και " Pisani" αποθηκευμένα με κενά.
  const first = String(sync.chartererFirstName || b.chartererFirstName || b.skipperFirstName || '').trim();
  const last  = String(sync.chartererLastName  || b.chartererLastName  || b.skipperLastName  || '').trim();

  const clientName   = (b.clientName || `${first} ${last}`).trim();
  const checkInDate  = b.checkInDate  || b.startDate || sync.startDate || '';
  const checkOutDate = b.checkOutDate || b.endDate   || sync.endDate   || '';

  return {
    bookingCode:        b.bookingCode || b.code || b.charterCode || b.bookingNumber || '',
    clientName,
    chartererFirstName: first,
    chartererLastName:  last,
    chartererEmail:     b.chartererEmail    || sync.chartererEmail || '',
    chartererPhone:     b.chartererPhone    || sync.chartererPhone || '',
    chartererPassport:  b.chartererPassport || '',
    agency:             b.agency     || b.broker   || '',
    vesselName:         b.vesselName || b.boatName || sync.vesselName || '',
    // «Ημερομηνία παράδοσης» = checkInDate, κατ' απόφαση. Δεν υπάρχει ούτε
    // χρειάζεται ξεχωριστό πεδίο παράδοσης sea scooter.
    checkInDate,
    checkOutDate,
    charterDates: (checkInDate && checkOutDate) ? `${checkInDate} - ${checkOutDate}` : (checkInDate || ''),
    signDate: todayISO(),   // ημερομηνία υπογραφής/αποδοχής = σήμερα
    _sync: sync,
  };
}

// Ονόματα placeholders που επιτρέπονται μέσα σε κείμενα documents.
// Ό,τι δεν είναι εδώ, το translate-item.php guard θα το δει ως «invented».
export const BOOKING_PLACEHOLDERS = [
  'bookingCode', 'clientName', 'chartererFirstName', 'chartererLastName',
  'chartererEmail', 'chartererPhone', 'chartererPassport',
  'agency', 'vesselName', 'checkInDate', 'checkOutDate', 'charterDates', 'signDate',
];

// Αντικατάσταση {{token}} → τιμή. Άγνωστο ή κενό token → κενό string,
// ώστε να μη διαρρεύσει ποτέ «{{...}}» σε κείμενο που βλέπει πελάτης.
export function fillPlaceholders(text, fields) {
  if (!text) return text;
  const f = fields || {};
  return String(text).replace(/\{\{([A-Za-z0-9_]+)\}\}/g, (_m, key) => {
    const v = f[key];
    return (v === undefined || v === null) ? '' : String(v);
  });
}

// Εύρεση ναύλου με το ΑΥΣΤΗΡΟ codeMatches (utils/searchUtils), ίδιο με
// CharterAgreementPage:750 — όχι digits-only σύγκριση.
export function findBookingByCode(list, code) {
  if (!code) return null;
  const arr = Array.isArray(list) ? list : Object.values(list || {});
  return arr.find(b =>
    codeMatches(
      String(b?.bookingCode || b?.code || b?.charterCode || b?.bookingNumber || b?.id || ''),
      String(code)
    )
  ) || null;
}
